import React from 'react';
import * as XLSX from 'xlsx';

const FlashTestWitness = () => {
  const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');
  const flashTestData = inspectionData.FlashTestWitnessRecordAfterCalibration;

  if (!flashTestData || !flashTestData.date || !flashTestData.shift) {
    return <p className="text-gray-500">No Flash Test Witness data available</p>;
  }

  // Function to download data as Excel
  const downloadExcel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheetData = [];

    // Headers for the Excel sheet
    worksheetData.push([
      'Line',
      'Module ID',
      'Test Date',
      'Test Time',
      'FF',
      'IMP',
      'ISC',
      'Module Efficiency',
      'PMAX',
      'Rated Current',
      'VMP',
      'VOC',
    ]);

    // Populate data for each line and module
    Object.entries(flashTestData).forEach(([key, value]) => {
      if (key === 'date' || key === 'shift') return; // Skip top-level date and shift
      const lineData = value;
      lineData.modules.forEach((module) => {
        worksheetData.push([
          key,
          module.moduleId,
          module.testDate,
          module.testTime,
          module.ff,
          module.imp,
          module.isc,
          module.moduleEfficiency,
          module.pmax,
          module.ratedCurrent,
          module.vmp,
          module.voc,
        ]);
      });
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'FlashTestWitness');
    XLSX.writeFile(workbook, 'FlashTestWitnessData.xlsx');
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-gray-800">
          Flash Test Witness Data - {flashTestData.date} ({flashTestData.shift})
        </h2>
        <button
          onClick={downloadExcel}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none"
        >
          Download Excel
        </button>
      </div>

      {Object.entries(flashTestData).map(([lineKey, lineData]) => {
        if (lineKey === 'date' || lineKey === 'shift') return null; // Skip non-line keys
        return (
          <div key={lineKey} className="border-b pb-4">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">{lineKey}</h3>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border rounded-lg">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="px-4 py-2 text-left text-gray-700">Module ID</th>
                    <th className="px-4 py-2 text-left text-gray-700">Test Date</th>
                    <th className="px-4 py-2 text-left text-gray-700">Test Time</th>
                    <th className="px-4 py-2 text-left text-gray-700">FF</th>
                    <th className="px-4 py-2 text-left text-gray-700">IMP</th>
                    <th className="px-4 py-2 text-left text-gray-700">ISC</th>
                    <th className="px-4 py-2 text-left text-gray-700">Module Efficiency</th>
                    <th className="px-4 py-2 text-left text-gray-700">PMAX</th>
                    <th className="px-4 py-2 text-left text-gray-700">Rated Current</th>
                    <th className="px-4 py-2 text-left text-gray-700">VMP</th>
                    <th className="px-4 py-2 text-left text-gray-700">VOC</th>
                  </tr>
                </thead>
                <tbody>
                  {lineData.modules.map((module, index) => (
                    <tr key={index} className="border-t">
                      <td className="px-4 py-2 text-gray-600">{module.moduleId || 'N/A'}</td>
                      <td className="px-4 py-2 text-gray-600">{module.testDate || 'N/A'}</td>
                      <td className="px-4 py-2 text-gray-600">{module.testTime || 'N/A'}</td>
                      <td className="px-4 py-2 text-gray-600">{module.ff || 'N/A'}</td>
                      <td className="px-4 py-2 text-gray-600">{module.imp || 'N/A'}</td>
                      <td className="px-4 py-2 text-gray-600">{module.isc || 'N/A'}</td>
                      <td className="px-4 py-2 text-gray-600">{module.moduleEfficiency || 'N/A'}</td>
                      <td className="px-4 py-2 text-gray-600">{module.pmax || 'N/A'}</td>
                      <td className="px-4 py-2 text-gray-600">{module.ratedCurrent || 'N/A'}</td>
                      <td className="px-4 py-2 text-gray-600">{module.vmp || 'N/A'}</td>
                      <td className="px-4 py-2 text-gray-600">{module.voc || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FlashTestWitness;